import { isUnifiedPositionEnabled } from "app/components/campaigns/shared/utils";

export const getTrackOverallPositionApiParam = (
    trackOverallPosition?: string,
): { trackOverallPosition: boolean } | Record<string, never> => {
    if (isUnifiedPositionEnabled()) {
        return {};
    }
    return { trackOverallPosition: trackOverallPosition === "true" };
};
